import React from 'react';
import { componentService } from 'js/services/component.service';

export const UserInfo = React.lazy(() => import(/* webpackChunkName: "user-info" */ './UserInfo'));

// <hub2-user-info property="addressDetails.buildingName"></hub2-user-info>
componentService.registerWebContentComponents({ UserInfo });
